import React from 'react';
import classes from './DaySelector.module.scss';
import { WithTypedChildren } from '../../../../models/children-props';
import classNames from 'classnames';

export type DaySelectorViewProps = WithTypedChildren<string> & {
  //
  action: VoidFunction;
  selected: boolean;
};

export const DaySelectorView = (props: DaySelectorViewProps): JSX.Element => {
  const globalClasses = classNames(classes.DaySelector, { [classes.DaySelectorSelected]: props.selected });
  return (
    <button className={globalClasses} onClick={() => props.action()}>
      {props.children}
    </button>
  );
};
